import { ClientId } from '../interfaces/SharingInterfaces';
import PlatformDetection from '@ms/odsp-utilities/lib/browser/PlatformDetection';

export function isOfficeProduct(clientId: ClientId): boolean {
    return isWord(clientId) || isPowerPoint(clientId) || isExcel(clientId) || isVisio(clientId) || isOneNote(clientId) || isUnionApp(clientId);
}

export function isODSP(clientId: ClientId): boolean {
    return clientId === ClientId.odb || clientId === ClientId.sharePoint || clientId === ClientId.odc;
}

export function isOutlook(clientId: ClientId): boolean {
    return clientId === ClientId.outlookWeb ||
        clientId === ClientId.outlookWindows ||
        clientId === ClientId.outlookMac;
}

export function isIos(clientId: ClientId): boolean {
    return clientId === ClientId.odIos ||
        clientId === ClientId.wordIos ||
        clientId === ClientId.excelIos ||
        clientId === ClientId.visioIos ||
        clientId === ClientId.onenoteIos ||
        clientId === ClientId.powerpointIos ||
        clientId === ClientId.teamsIos;
}

export function isAndroid(clientId: ClientId): boolean {
    return clientId === ClientId.odAndroid ||
        clientId === ClientId.wordAndroid ||
        clientId === ClientId.excelAndroid ||
        clientId === ClientId.visioAndroid ||
        clientId === ClientId.onenoteAndroid ||
        clientId === ClientId.powerpointAndroid ||
        clientId === ClientId.teamsAndroid;
}

export function isMobile(clientId: ClientId): boolean {
    return isIos(clientId) || isAndroid(clientId);
}

export function hideItemName(clientId: ClientId, platformDetection: PlatformDetection): boolean {
    return isOfficeProduct(clientId) &&
        !platformDetection.isMac &&
        clientId !== ClientId.onenoteUWP;
}

export function showCloseButton(clientId: ClientId): boolean {
    return isODSP(clientId) ||
        clientId === ClientId.onenoteWeb ||
        clientId === ClientId.outlookWeb ||
        clientId === ClientId.officecom ||
        isMobile(clientId);
}

export function showOWAShareTarget(clientId: ClientId): boolean {
    return isODSP(clientId) || clientId === ClientId.officecom || clientId === ClientId.wac;
}

export function invertPermissionsButtonsOrder(clientId: ClientId) {
    return isMobile(clientId) || isTeams(clientId);
}

export function isWord(clientId: ClientId): boolean {
    return clientId === ClientId.word || clientId === ClientId.wordAndroid || clientId === ClientId.wordIos;
}

export function isExcel(clientId: ClientId): boolean {
    return clientId === ClientId.excel || clientId === ClientId.excelAndroid || clientId === ClientId.excelIos;
}

export function isPowerPoint(clientId: ClientId): boolean {
    return clientId === ClientId.powerpoint || clientId === ClientId.powerpointAndroid || clientId === ClientId.powerpointIos;
}

export function isVisio(clientId: ClientId): boolean {
    return clientId === ClientId.visio || clientId === ClientId.visioIos || clientId === ClientId.visioAndroid;
}

export function isOneNote(clientId: ClientId): boolean {
    return clientId === ClientId.onenote ||
        clientId === ClientId.onenoteWeb ||
        clientId === ClientId.onenoteUWP ||
        clientId === ClientId.onenoteIos ||
        clientId === ClientId.onenoteAndroid;
}

export function isTeams(clientId: ClientId): boolean {
    return clientId === ClientId.teams || clientId === ClientId.teamsIos || clientId === ClientId.teamsAndroid;
}

export function isUnionApp(clientId: ClientId): boolean {
    return clientId === ClientId.officemobileIos || clientId === ClientId.officemobileAndroid;
}